// Custom JavaScript added by Dibas

$(document).ready(function(){
  
  $(".more_prod_btn").click(function(){
    $(".more_product_data").slideToggle();
    
    $(this).text(function(i, v){
               return v === '+ More' ? '- Less' : '+ More'
    })
    
  });
  
  
  
  $(".more_offers_btn").click(function(){
    $(".more_offers_data").slideToggle();
    
    $(this).text(function(i, v){
               return v === 'view more' ? 'view less' : 'view more'
    })
    
  });
  
  
  $('.howtowear_bxslider').bxSlider();
  $('.howtowash_machine_bxslider').bxSlider();
  $('.howtowash_hand_bxslider').bxSlider();
  
});


function customSumArray(a, b) {
      var c = [];
      for (var i = 0; i < Math.max(a.length, b.length); i++) {
        c.push((a[i] || 0) + (b[i] || 0));
      }
      return c;
}


function calculateEcoSavings(productName, quantity) {
  
    const diaper = [250000, 136, 23, 9, 1287, 2550700];
  
	var calculatedValues = diaper.map(function(x) { return x * quantity; });
  
	return calculatedValues;
  
}

